import '../scss/main.scss';
import IsDraggable from './components/IsDraggable';
import Hero from './components/Hero';
import Footer from './components/Footer';
import SubMenu from './components/SubMenu';
import Nav from './components/Nav';
import HideOnScroll from './components/HideOnScroll';
import Gallery from './components/Gallery';
import Accordion from './components/Accordion';
import EagerlyMailSubscription from './components/EagerlyMailSubscription';
import Plyr from 'plyr';

import './react/agenda';

document.querySelectorAll('.js-accordion').forEach((el) => {
  new Accordion(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
  new HideOnScroll(el);
});

document.querySelectorAll('.js-draggable').forEach((el) => {
  new IsDraggable(el);
});

document.querySelectorAll('.js-hero').forEach((el) => {
  new Hero(el);
});

document.querySelectorAll('.js-footer').forEach((el) => {
  new Footer(el);
});

document.querySelectorAll('.js-nav').forEach((el) => {
  new Nav(el);
});

document.querySelectorAll('.js-gallery').forEach((el) => {
  new Gallery(el);
});

// Newsletter Sign up
document.querySelectorAll('.js-newsletter').forEach((el) => new EagerlyMailSubscription(el));

document.querySelectorAll('.plyr--video').forEach((video) => {
	// console.log(video);
  new Plyr(video, {
    // autoplay: 1,
    loop: { active: true },
    youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
  });
});

document.querySelectorAll('.js-sub-menu').forEach((el) => {
  const breakpoint = window.matchMedia(el.dataset.breakpoint);
  let instance = null;

  if (breakpoint.matches) {
    instance = new SubMenu(el);
    el.dataset.initialised = true;
  }

  breakpoint.addEventListener('change', (e) => {
    if (e.matches) {
      instance = new SubMenu(el);
      el.dataset.initialised = true;
    } else {
      instance.unmount();
      el.dataset.initialised = false;
    }
  });
});

